// Navigation.jsx
import { ArrowLeft, ArrowRight } from "./Icons";
import { getMergedStyles } from "./getMergedStyles";

export default function Navigation(props) {
  const { onNext, onPrevious, styleOverrides } = props;
  const arrowSize = 20;

  const [containerClassName, containerInlineStyle] = getMergedStyles(
    "absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-4 z-50",
    null,
    styleOverrides?.Navigation
  );

  const [iconClassName, iconInlineStyle] = getMergedStyles(
    "bg-black/60 hover:bg-black/80 p-2 rounded-full cursor-pointer transition-colors duration-300",
    null,
    styleOverrides?.NavIcon
  );

  return (
    <nav style={containerInlineStyle} className={containerClassName}>
      <div style={iconInlineStyle} onClick={onPrevious} className={iconClassName}>
        <ArrowLeft color="#fff" size={arrowSize} />
      </div>
      <div style={iconInlineStyle} onClick={onNext} className={iconClassName}>
        <ArrowRight color="#fff" size={arrowSize} />
      </div>
    </nav>
  );
}